import React from "react";
import { Link } from "react-router-dom";
import "../pages/cx.css"; // theme tokens
import "./page.css";

/**
 * Shell for the public content pages (about, features, pricing, contact).
 * `children` sit on a white sheet under a themed hero.
 */
const PageLayout = ({ title, description, children }) => (
  <div className="pub-page">
    <section className="pub-hero">
      <div className="pub-container">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
    </section>

    <section className="pub-content">
      <div className="pub-container">
        <div className="pub-sheet">{children}</div>
      </div>
    </section>

    <footer className="pub-footer">
      © {new Date().getFullYear()} Nnetego. All rights reserved. <Link to="/legal/privacy">Privacy</Link> · <Link to="/legal/terms">Terms</Link>
    </footer>
  </div>
);

export default PageLayout;
